import type { SelfItemKey, VisaCountry } from '../types';

/**
 * Полный чек-лист «сделать самому»: страны MVP используют его целиком,
 * различия в составе появятся вместе с новыми странами.
 */
const ALL_SELF_ITEMS: SelfItemKey[] = [
  'print-and-sign',
  'bank-statement',
  'employment-letter',
  'photo',
  'consular-fee',
  'appointment',
];

/**
 * Реестр стран раздела «Визы». Критерий приёмки: новая страна добавляется
 * одной записью здесь плюс переводы — без правок экранов.
 *
 * Контент (визовые центры, суммы и сроки в локалях) вычитывается продуктом
 * с сайтов консульств до включения флага VISA_HELP.
 */
export const VISA_COUNTRIES: VisaCountry[] = [
  {
    code: 'CY',
    isActive: true,
    // TODO(AVIATA-3669): проверить статус Кипра по Шенгену на дату релиза —
    // от kind зависит шаблон анкеты на бэке.
    kind: 'national',
    blocks: ['flight', 'accommodation', 'form', 'insurance'],
    selfItems: ALL_SELF_ITEMS,
    destinationAirports: ['LCA', 'PFO'],
    destinationNames: ['Кипр', 'Cyprus'],
    visaCenter: {
      // TODO(AVIATA-3669): реквизиты визового центра уточнить у продукта
      // до включения флага (адрес — из прототипа).
      name: 'VFS Global',
      url: 'https://visa.vfsglobal.com',
      address: 'ул. Байтурсынова 90, Алматы',
    },
    version: '2026-07-29',
  },
  {
    code: 'HU',
    isActive: true,
    kind: 'schengen',
    blocks: ['flight', 'accommodation', 'form', 'insurance'],
    selfItems: ALL_SELF_ITEMS,
    destinationAirports: ['BUD', 'DEB'],
    destinationNames: ['Венгрия', 'Венгрия Республикасы', 'Hungary'],
    visaCenter: {
      // TODO(AVIATA-3669): реквизиты визового центра уточнить у продукта
      // до включения флага (адрес — из прототипа).
      name: 'VFS Global',
      url: 'https://visa.vfsglobal.com/kaz/ru/hun',
      address: 'ул. Байтурсынова 90, Алматы',
    },
    version: '2026-07-29',
  },
  { code: 'FR', isActive: false, kind: 'schengen' },
  { code: 'DE', isActive: false, kind: 'schengen' },
  { code: 'TR', isActive: false, kind: 'national' },
  { code: 'GB', isActive: false, kind: 'national' },
];
